var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.09091 11.4925L3.27273 7.73134L2 8.98507L7.09091 14L18 3.25373L16.7273 2L7.09091 11.4925Z","fill":"#83EABF","stroke":"#83EABF","strokeWidth":"2"}));
}

Check.defaultProps = {"width":"20","height":"16","viewBox":"0 0 20 16","fill":"none"};

module.exports = Check;

Check.default = Check;
